export default function SectionApp() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1000px] mx-auto">
        <div className="bg-gradient-to-br from-foreground-900 to-foreground-800 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none" style={{
            background: 'radial-gradient(ellipse 60% 50% at 70% 30%, oklch(0.52 0.22 25 / 0.25), transparent)',
          }}></div>
          <div className="relative z-10 flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
              随时随地吃瓜
            </h2>
            <p className="text-background-50/70 text-sm md:text-base max-w-md mx-auto lg:mx-0 leading-relaxed mb-5">
              911吃瓜网移动端适配完美，无论你在地铁、咖啡厅还是床上，
              打开手机就能浏览全网最新黑料。支持夜间模式，深夜吃瓜不刺眼。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/15 text-background-50 text-sm rounded-full border border-background-50/20 whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-colors">
                <i className="ri-android-line text-lg"></i>
                Android 版
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/15 text-background-50 text-sm rounded-full border border-background-50/20 whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-colors">
                <i className="ri-apple-line text-lg"></i>
                iOS 版
              </span>
            </div>
          </div>
          <div className="relative z-10 flex-shrink-0">
            <div className="w-48 h-80 bg-background-50/10 rounded-2xl border border-background-50/20 flex items-center justify-center">
              <i className="ri-smartphone-line text-6xl text-background-50/30"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}